<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('productProfile.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('productProfile.pageTitle'),
            href: '/admin/product-profiles'
          },
          {
            text: $t('create'),
            active: true
          }
        ]"
      />
    </div>
    <ts-loading-banner :loading="loading">
      <div class="row">
        <div class="col-md-9">
          <ts-card class="ts-h-full">
            <ts-card-wrapper>
              <ProductInfo
                v-model="model"
                :validate="errors"
                @loading="value => (loading = value)"
                class="ts-p-4 ts-rounded-lg ts-border-gray-200"
              />
              <br />
              <ProSaleCodeList v-model="model" :validate="errors" />
            </ts-card-wrapper>
          </ts-card>
        </div>
        <div class="col-md-3">
          <ts-card>
            <ts-card-wrapper>
              <ProductPhoto
                v-model="model"
                :validate="errors"
                class="ts-w-full ts-p-4 ts-rounded-lg m-auto"
              />
            </ts-card-wrapper>
          </ts-card>
          <ts-card>
            <ts-card-wrapper class="ts-space-y-2">
              <BranchList v-model="model" :validate="errors" />
              <VendorList v-model="model" :validate="errors" />
            </ts-card-wrapper>
          </ts-card>
          <ts-card>
            <ts-card-wrapper class="ts-space-y-2">
              <AddOnItem v-model="model" :validate="errors" />
              <LocationAssign v-model="model" :validate="errors" />
            </ts-card-wrapper>
          </ts-card>
        </div>
      </div>
      <div class="row ts-mt-4">
        <div class="col-md-12">
          <div
            class="ts-w-full ts-bg-white ts-p-2 ts-rounded-md ts-space-x-2 ts-flex ts-justify-end"
          >
            <ts-button
              @click.prevent="$router.push({ name: 'product-profile' })"
              >{{ $t('cancel') }}</ts-button
            >
            <ts-button
              color="primary"
              outline
              :waiting="waiting_new"
              @click.prevent="saveAddNew"
              >{{ $t('save_add_new') }}</ts-button
            >
            <ts-button
              color="primary"
              :waiting="waiting"
              @click.prevent="save"
              >{{ $t('save') }}</ts-button
            >
          </div>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'
import ProductPhoto from './components/product-photo.vue'
import ProductInfo from './components/product-info.vue'
import BranchList from './components/branch-list.vue'
import VendorList from './components/vendor-list'
import ProSaleCodeList from './components/pro-sale-code-list.vue'
import AddOnItem from './components/add-on-item'
import LocationAssign from './components/location-assign.vue'

export default {
  name: 'productProfile',
  components: {
    ProductPhoto,
    ProductInfo,
    BranchList,
    ProSaleCodeList,
    VendorList,
    AddOnItem,
    LocationAssign
  },
  data () {
    return {
      errors: new Errors(),
      waiting_new: false,
      waiting: false,
      loading: false,
      file: null,
      model: {
        product_id: 0,
        category_id: null,
        product_name_kh: null,
        product_name_en: null,
        barcode: null,
        uom_cat_id: null,
        product_type_id: 2,
        pro_group_id: null,
        product_mode_id: 1,
        age_eligible_from: null,
        age_eligible_to: null,
        minimum_reorder_qty: null,
        maximum_reorder_allow: null,
        is_expirable: false,
        is_feature: false,
        vat_eligible: false,
        is_generate_unique_serial: false,
        dashboard_stock_tracking: false,
        is_min_max_stock_report: false,
        photo: null,
        product_sale_code: [],
        other_branch_list: [],
        vendor_list: [],
        recipes: [],
        location: [],
        account_id: undefined,
        require_imei: false,
        is_warranty: false,
        is_sparepart_cost: false
      }
    }
  },
  methods: {
    ...mapActions('product/profile', [
      'fetchBefore',
      'store',
      'upload',
      'formViewModel'
    ]),
    async uploadPhoto (id) {
      if (this.file instanceof File || this.file instanceof Blob) {
        if (id > 0) {
          let formData = new FormData()
          formData.append('photo', this.file)
          await this.upload({
            id: id,
            data: formData
          })
        }
      }
    },
    save () {
      let { photo, ...dataSend } = this.model
      this.file = photo
      this.waiting = true
      this.errors = new Errors()
      this.store(dataSend)
        .then(async response => {
          await this.uploadPhoto(response.product_id)
          this.$toasted.success(response.message)
          this.$router.push({ name: 'product-profile' })
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    saveAddNew () {
      let { photo, ...dataSend } = this.model
      this.file = photo
      this.waiting_new = true
      this.errors = new Errors()
      this.store(dataSend)
        .then(async response => {
          await this.uploadPhoto(response.id)
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting_new = false
        })
    },
    clearInput () {
      this.model.product_id = 0
      this.model.category_id = null
      this.model.product_name_kh = null
      this.model.product_name_en = null
      this.model.barcode = null
      this.model.uom_cat_id = null
      this.model.product_type_id = 2
      this.model.product_mode_id = 1
      this.model.age_eligible_from = null
      this.model.age_eligible_to = null
      this.model.minimum_reorder_qty = null
      this.model.maximum_reorder_allow = null
      this.model.is_expirable = false
      this.model.vat_eligible = false
      this.model.dashboard_stock_tracking = false
      this.model.is_min_max_stock_report = false
      this.model.is_generate_unique_serial = false
      this.model.photo = null
      this.model.product_sale_code = []
      this.model.other_branch_list = []
      this.model.vendor_list = []
      this.model.recipes = []
      this.model.location = []
      this.model.account_id = undefined
      this.model.require_imei = false
      this.model.is_warranty = false
      this.model.is_sparepart_cost = false
      this.file = null
      this.errors = new Errors()
    },
    assingLocationDefaultToModel () {
      const defaultLocation = this.$store.state.product.profile.locations.find(
        l => l.is_default
      )
      if (defaultLocation !== undefined) {
        this.model.location.push(defaultLocation.location_id)
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('product/profile/CLEAR_SETUP')
    next()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.loading = true
      vm.fetchBefore()
        .then(() => vm.assingLocationDefaultToModel())
        .finally(() => (vm.loading = false))
    })
  }
}
</script>
